<template>
  <div class="priority-item queue-failed">
    <div class="d-flex align-items-center gap-50">
      <i class="far fa-times queue-icon lh-inherit"></i>
      <h2>{{ 'Oops, this didn\'t work' | trans }}</h2>
    </div>
    <p>
      {{ 'It looks like there was an issue. We dispatched our seal team to solve this issue.' | trans }}
    </p>
    <h2 v-if="currentJob.apiJob?.status.code === 'failed' && isFreeUser">{{ 'Queue overload!' | trans }}</h2>
    <p class="font-weight-bold" v-if="currentJob.apiJob?.status.code === 'failed' && isFreeUser">
      {{ 'We are happy that so many users are using this service and have already dispatched our seal team to order new servers.' | trans }}
    </p>
    <p v-if="currentJob.apiJob?.status.code === 'failed' && isFreeUser">
      {{ 'Get a subscription to bypass the queue, enjoy PRO features and process your files faster.' | trans }}
    </p>

    <p>
      {{ 'No Credits have been deducted.' | trans  }}
    </p>
    <button v-if="currentJob.apiJob?.status.code === 'failed' && isFreeUser" class="btn queue-btn bg-warning w-50" @click="openPremiumModal">
      <i class="fa fa-chevron-right"></i><strong>{{ 'Get Premium' | trans }}</strong>
    </button>
  </div>
</template>
<script>
import store from './../../../mixins/store.mixin'
import currentJob from './../../../mixins/current_job.mixin'
import {
  registerPaymentModalHelper
} from "../../../../../../../../lib-sat/user/modal/register_payment_flow/register-payment-modal-helper";
import user from "../../../mixins/user.mixin";
import Analytics from "../../../util/Analytics";

export default {
  name: "QueueFailed",
  props: {},
  components: {},
  mixins: [
    store,
    currentJob,
    user,
  ],
  data() {
    return {};
  },
  mounted: function () {
  },
  created: function () {
  },
  methods: {
    openPremiumModal() {
      Analytics.send('creator_studio_action', `get_premium_queue_failed`, this.currentJob);

      registerPaymentModalHelper.openUpgrade().then(() => {
        this.modalToShow = null;
      });
    },
  },
  computed: {
  }
};
</script>
<style lang="scss">

</style>
